import { addTaskListItemfileThunk } from '../../../redux/thunks/task';
import { AttachFile } from '@mui/icons-material';
import CustomModal from '../../modals';
import ImageInput from '../../reusable/input/file_input';
import { useParams } from 'react-router';
import { useState } from 'react';
import { AppDispatch, RootState } from '../../../redux/store';
import { Box, Button, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

const TaskFilePickerModal = ({ open, onClose, selectedId }: { open: boolean; onClose: () => void; selectedId: number }) => {
    const dispatch = useDispatch<AppDispatch>();
    const { id } = useParams<{ id: string }>();
    const { loaders } = useSelector((state: RootState) => state.task);
    const [fileValue, setFileValue] = useState<string | null>(null);

    const handleFileSave = async () => {
        // const formattedTimestamp = new Date().toISOString().replace(/-/g, '').replace(/:/g, '').replace(/\..+/, '');
        try {
            // const fileFormat = fetchImageFormatFromBase64(fileValue as string);
            const data = {
                id: selectedId,
                file: fileValue as string,
                filename: Date.now().toString(),
                client_id: id ? parseInt(id as string, 10) : 0
            };
            await dispatch(addTaskListItemfileThunk(data)).unwrap();
            onClose();
        } catch (e) {
            // Catch errors
        }
    };

    return (
        <CustomModal open={open} handleClose={loaders.isCreating ? () => null : onClose} title="Upload File">
            <Typography variant="body2" textAlign="center" marginBottom="10px">Please upload File.</Typography>
            <ImageInput
                title="File"
                value={fileValue}
                onChange={(value) => setFileValue(value)}
                icon={<AttachFile />}
                disabled={loaders.isCreating}
            />
            <Box display="flex" gap="20px" marginTop="20px">
                <Button
                    variant="outlined"
                    color="secondary"
                    onClick={onClose} fullWidth disabled={loaders.isCreating}
                >
                    Cancel
                </Button>
                <Button variant="contained" fullWidth onClick={handleFileSave} disabled={loaders.isCreating}>{loaders.isCreating ? 'Adding...' : 'Add'}</Button>
            </Box>
        </CustomModal>);
};

export default TaskFilePickerModal;